<!-- Error messages container -->
@if (errorPayload().length > 0) {
<div class="common-error-panel">
  <!-- Optional problem headline -->
  @if (showProblem()) {
  <ion-text class="fw-semibold mb-2">
    {{ 'MSG77' | translate }}
  </ion-text>
  }

  <!-- Error message list -->
  @for (message of uniqueErrors; track $index) {
  @if(message.trim().length === 0){
  <br>
  }
  <ion-text class="d-block text-danger-accent fw-normal">
    {{ message | translate }}
  </ion-text>
  }
</div>
}